var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4395 12.8729C7.8696 12.8729 9.2588 12.3957 10.387 11.517L14.6436 15.7735C14.9615 16.0806 15.4682 16.0718 15.7753 15.7538C16.0749 15.4436 16.0749 14.9519 15.7753 14.6417L11.5188 10.3852C13.6994 7.5782 13.1916 3.53493 10.3846 1.35433C7.57755 -0.826274 3.53432 -0.318486 1.35372 2.48854C-0.826884 5.29557 -0.319097 9.33883 2.48793 11.5194C3.61801 12.3973 5.00846 12.8736 6.4395 12.8729ZM3.01943 3.01758C4.9083 1.12867 7.97076 1.12864 9.85967 3.01751C11.7486 4.90638 11.7486 7.96884 9.85974 9.85775C7.97087 11.7467 4.9084 11.7467 3.0195 9.85782C3.01946 9.85778 3.01946 9.85778 3.01943 9.85775C1.13056 7.98264 1.11943 4.93134 2.99454 3.04247C3.00282 3.03415 3.01111 3.02587 3.01943 3.01758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7732abb9539b9bf3fb1f2f908ac15219.svg";
export { ForwardRef as ReactComponent };